<script lang="ts">
	import ArticleStructuredData from "@components/ArticleStructuredData.svelte";
	import Attachments from "@components/Attachments.svelte";
	import CaseStudyCard from "@components/CaseStudyCard.svelte";
	import ContentBlocks from "@components/ContentBlocks.svelte";
	import HugeHeading from "@components/HugeHeading.svelte";
	import Formatted from "@components/common/Formatted.svelte";
	import Media from "@components/common/Media.svelte";
	import ShareButton from "@components/common/ShareButton.svelte";
	import GalleryBlock from "@components/content-blocks/GalleryBlock.svelte";
	import Layout from "@components/layout/Layout.svelte";
	import { findImageInContentBlocks } from "@core/schema/utils/findImageInContentBlocks.js";
	import type { CaseStudiesDetailProps } from "./CaseStudiesDetailProps.js";

	const { caseStudy, related }: CaseStudiesDetailProps = $props();
</script>

<ArticleStructuredData article={caseStudy} />

<Layout ogImage={caseStudy.primaryImage ?? caseStudy.images[0] ?? findImageInContentBlocks(caseStudy.content)}>
	<section class="full-width grid-container mx-auto flex flex-col pb-8 md:pb-16 lg:pb-20">
		<div class="flex flex-col gap-4 mb-10 max-w-[calc(72rem+var(--container-gap)] mx-auto">
			<div class="flex flex-col gap-4 max-w-screen-md mx-auto">
				<HugeHeading level={1} text={caseStudy.title} class="lg:!text-9xl !mb-0 mild" />
				{#if caseStudy.perex}
					<p class="text-[1.25rem]/[1.5] md:text-xl/[1.5] font-semibold max-w-screen-md">
						<Formatted text={caseStudy.perex} />
					</p>
				{/if}
				{#if caseStudy.primaryImage}
					<div class="bg-white rounded-lg p-4 mt-6 md:mt-8 lg:mt-12">
						<Media
							class="rounded-lg"
							source={caseStudy.primaryImage}
							alt="Úvodní fotka"
							width={736}
							height={414}
							sourcesets={{
								"<2xl": [414, 0],
								">2xl": [414, 0],
							}}
						/>
					</div>
				{/if}
				<ShareButton />
			</div>
		</div>
		<ContentBlocks blocks={caseStudy.content} lightboxIdPerBlock align="center" />
		{#if caseStudy.images.length > 0}
			<div class="mt-16">
				<GalleryBlock data={{ images: caseStudy.images }} lightboxId={undefined} align="center" />
			</div>
		{/if}
		<Attachments attachments={caseStudy.attachments} />
	</section>
	{#if related.length > 0}
		<section class="pb-8 md:pb-16 lg:pb-20 2xl:full-width 2xl:!px-[var(--container-gap)]">
			<div class="2xl:max-w-[120.5rem] 2xl:mx-auto">
				<HugeHeading level={2} text="Další posty" />
				<div class="grid-container">
					<div class="grid gap-1 md:gap-2 md:justify-center grid-cols-2 lg:grid-cols-3">
						{#each related as caseStudy (caseStudy.id)}
							<CaseStudyCard {caseStudy} class="min-h-[19.125rem] md:min-h-[24.75rem]" />
						{/each}
					</div>
				</div>
			</div>
		</section>
	{/if}
</Layout>
